import React from "react";
import {
  ListItem,
  ListItemText,
  Button,
  Box,
  Typography,
  Divider,
  Paper,
  Stack,
} from "@mui/material";
import { Notification } from "../../../../utils/commonApis";

interface PurchaseOrderNotificationProps {
  notification: Notification;
}

interface PurchaseOrderData {
  PurchaseOrderId: string;
  VendorName: string;
  TotalPrice: number;
  CreatedAt: number;
  [key: string]: any;
}

const PurchaseOrderNotification: React.FC<PurchaseOrderNotificationProps> = ({ notification }) => {
  // Parse the purchase order data from the notification
  let purchaseOrderData: PurchaseOrderData | null = null;
  try {
    purchaseOrderData = JSON.parse(notification.DataDump) as PurchaseOrderData;
  } catch (e) {
    console.error("Error parsing purchase order data:", e);
  }

  if (!purchaseOrderData) {
    return (
      <ListItem divider>
        <ListItemText 
          primary="Invalid Purchase Order Notification" 
          secondary={`Error parsing notification data. Created at: ${new Date(notification.CreatedAt * 1000).toLocaleString()}`}
        />
      </ListItem>
    );
  }

  return (
    <Paper elevation={1} sx={{ mb: 2, overflow: "hidden" }}>
      <ListItem sx={{ bgcolor: "#f8f9fa" }}>
        <ListItemText
          primary={
            <Typography variant="subtitle1" fontWeight="bold">
              Purchase Order Approval Request
            </Typography>
          }
          secondary={`Created: ${new Date(notification.CreatedAt * 1000).toLocaleString()}`}
        />
      </ListItem>
      <Divider />
      <Box sx={{ p: 2 }}>
        <Stack spacing={1}>
          <Typography variant="body2">
            <strong>Vendor:</strong> {purchaseOrderData.VendorName}
          </Typography>
          <Typography variant="body2">
            <strong>Order ID:</strong> {purchaseOrderData.PurchaseOrderId}
          </Typography>
          <Typography variant="body2">
            <strong>Total Amount:</strong> ₹{purchaseOrderData.TotalPrice.toFixed(2)}
          </Typography>
        </Stack>
      </Box>
      <Divider />
      <Box sx={{ p: 1.5, display: "flex", justifyContent: "flex-end", gap: 1 }}>
        {notification.Status === 'pending' && (
          <>
            <Button 
              variant="outlined" 
              color="error" 
              size="small"
            >
              Reject
            </Button>
            <Button 
              variant="contained" 
              color="primary" 
              size="small"
            >
              Approve
            </Button>
          </>
        )}
        {notification.Status === 'accepted' && (
          <Typography variant="body2" color="success.main">
            This purchase order has been approved
          </Typography>
        )}
        {notification.Status === 'rejected' && (
          <Typography variant="body2" color="error">
            This purchase order has been rejected
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default PurchaseOrderNotification;